import React, { useCallback, useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import request from "../../../../utils/Request.utils";
import { checkPasswordPatternCascade } from "../../../../utils/Common.utils";

const PASSWORD_MIN_LENGTH = 8;
const PASSWORD_MAX_LENGTH = 16;

const initialForm = {
  admin_id: "",
  admin_name: "",
  current_password: "",
  admin_pwd: "",
  admin_pwd_confirm: "",
};

const SettingManager = ({ pageTitle = "관리자 계정 관리" }) => {
  const [form, setForm] = useState(initialForm);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const loadAdminInfo = useCallback(() => {
    setIsLoading(true);

    const successHandler = (response) => {
      setIsLoading(false);
      if (response.messageCode !== 200 || !response.data) {
        toast.error("관리자 정보를 불러올 수 없습니다.");
        return;
      }

      setForm({
        admin_id: response.data.admin_id || "",
        admin_name: response.data.admin_name || "",
        current_password: "",
        admin_pwd: "",
        admin_pwd_confirm: "",
      });
    };

    const failHandler = () => {
      setIsLoading(false);
      toast.error("관리자 정보를 불러오는 중 오류가 발생했습니다.");
    };

    request.get("/admin/my", {}, successHandler, failHandler);
  }, []);

  useEffect(() => {
    loadAdminInfo();
  }, [loadAdminInfo]);

  const handleSubmit = () => {
    const adminName = form.admin_name.trim();
    const currentPassword = form.current_password.trim();
    const password = form.admin_pwd.trim();
    const passwordConfirm = form.admin_pwd_confirm.trim();

    if (!adminName) {
      toast.error("이름을 입력해 주세요.");
      return;
    }

    if (!currentPassword) {
      toast.error("기존 비밀번호를 입력해 주세요.");
      return;
    }

    if ((password || passwordConfirm) && password !== passwordConfirm) {
      toast.error("비밀번호가 일치하지 않습니다.");
      return;
    }

    if (password && (
      password.length > PASSWORD_MAX_LENGTH ||
      !checkPasswordPatternCascade(password, PASSWORD_MIN_LENGTH)
    )) {
      toast.error("새 비밀번호는 영문, 숫자, 특수문자 중 2가지 이상 포함 8~16자리로 입력해 주세요.");
      return;
    }

    const params = {
      admin_name: adminName,
      current_password: currentPassword,
    };

    if (password) {
      params.admin_pwd = password;
    }

    setIsSubmitting(true);

    const successHandler = (response) => {
      setIsSubmitting(false);
      if (response.messageCode === 200) {
        toast.success("내 정보가 수정되었습니다.");
        setForm((prev) => ({
          ...prev,
          admin_name: adminName,
          current_password: "",
          admin_pwd: "",
          admin_pwd_confirm: "",
        }));
        return;
      }

      toast.error(response.messageString || "내 정보 수정 중 오류가 발생했습니다.");
    };

    const failHandler = () => {
      setIsSubmitting(false);
      toast.error("내 정보 수정 중 오류가 발생했습니다.");
    };

    request.put("/admin/my", params, successHandler, failHandler);
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">{pageTitle}</h2>
      <table className="adm_com_board_list type_row">
        <colgroup>
          <col width="14%" /><col />
        </colgroup>
        <tbody>
          <tr>
            <th>아이디</th>
            <td>
              <input type="text" className="input" value={form.admin_id} disabled />
            </td>
          </tr>
          <tr>
            <th>이름</th>
            <td>
              <input
                type="text"
                className="input"
                value={form.admin_name}
                disabled={isLoading}
                onChange={(e) => handleChange("admin_name", e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <th>기존 비밀번호</th>
            <td>
              <input
                type="password"
                className="input"
                value={form.current_password}
                autoComplete="current-password"
                disabled={isLoading}
                onChange={(e) => handleChange("current_password", e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <th>새 비밀번호</th>
            <td>
              <input
                type="password"
                className="input"
                value={form.admin_pwd}
                autoComplete="new-password"
                maxLength={PASSWORD_MAX_LENGTH}
                disabled={isLoading}
                onChange={(e) => handleChange("admin_pwd", e.target.value)}
              />
            </td>
          </tr>
          <tr>
            <th>새 비밀번호 확인</th>
            <td>
              <input
                type="password"
                className="input"
                value={form.admin_pwd_confirm}
                autoComplete="new-password"
                maxLength={PASSWORD_MAX_LENGTH}
                disabled={isLoading}
                onChange={(e) => handleChange("admin_pwd_confirm", e.target.value)}
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="adm_com_btn_wrap center">
        <button className="adm_com_btn blue" onClick={handleSubmit} disabled={isLoading || isSubmitting}>
          수정
        </button>
      </div>
      <ToastContainer position="top-center" autoClose={2000} hideProgressBar />
    </main>
  );
};

export default SettingManager;
